module.exports = __webpack_public_path__ + "static/img/topRight.599ba71b.png";